import React, { useState, useContext } from 'react'
import TextField from '@mui/material/TextField'
import { Grid, Box, Typography, Container } from '@mui/material'
import { useNotifications } from '@toolpad/core/useNotifications'
import InputAdornment from '@mui/material/InputAdornment'
import Button from '@mui/material/Button'
// import FormControlLabel from '@mui/material/FormControlLabel'
// import Checkbox from '@mui/material/Checkbox'
import axios from '../services/axiosInstance'
import OtpDialog from '../components/OtpDialog'
import { CaptchaTokenContext } from '../context/CaptchaContext'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'

const StepOne = ({ onCompleteStepOne }) => {
  const notifications = useNotifications()
  const { token, uuid } = useContext(CaptchaTokenContext)
  console.log('Captcha Token:', token)
  console.log('UUID:', uuid)

  const [pin, setPin] = useState('')
  const [open, setOpen] = useState(false)
  const [phone, setPhone] = useState('')
  const [isDisabled, setIsDisabled] = useState(false)
  const [new2024BatchMembers
    //  setNew2024BatchMembers
  ] = useState(false)
  const [name, setName] = useState('')

  const handleOtpRequest = async () => {
    try {
      if (phone.length !== 10) {
        notifications.show('Please enter a valid 10-digit mobile number', {
          severity: 'error',
          autoHideDuration: 5000
        })
        return
      }

      setIsDisabled(true)
      await axios.post('/otp/request', {
        ...(new2024BatchMembers ? { isPinNotAssigned: true } : { pin }),
        phoneNumber: `+91${phone}`
      })
      setOpen(true)
      notifications.show(`OTP has been sent to ${phone}`, {
        severity: 'info',
        autoHideDuration: 3000
      })
    } catch (error) {
      if (error.response) {
        // Server responded with a status other than 2xx
        console.error('API Error:', error.response.data)
        window.alert(error.response.data.message || 'Something went wrong')
      } else if (error.request) {
        // Request was made but no response received
        console.error('No response:', error.request)
        window.alert('No response from server. Please try again.')
      } else {
        // Other errors (like setting up the request)
        console.error('Error:', error.message)
        window.alert('Error: ' + error.message)
      }
      notifications.show('Error occurred while resending OTP', {
        severity: 'error',
        autoHideDuration: 3000
      })
    } finally {
      setIsDisabled(false)
    }
  }

  // const handleCheckboxChange = (event) => {
  //   setNew2024BatchMembers(event.target.checked)
  //   setPin('') // Clear PIN if checkbox is checked
  //   setName('') // Clear name if checkbox is checked
  // }

  const handleOnVerifyOtp = () => {
    setOpen(false)
    onCompleteStepOne({ phone, pin, new2024BatchMembers, name })
  }

  const handlePinChange = async (event) => {
    try {
      const value = event.target.value
      if (/^[a-zA-Z0-9]*$/.test(value)) {
        setPin(value)
        if (value.length >= 5) {
          const response = await axios.get('/user/getName', {
            params: {
              pin: value,
              cfIdempotencyKey: uuid
            },
            headers: {
              'cf-turnstile-response': token
            }
          })
          setName(response.data.data.name)
        } else {
          setName('')
        }
      }
    } catch (error) {
      console.error('Error in handlePinChange:', error)
    }
  }

  return (
    <Container maxWidth='md' sx={{ my: 2 }}>
      <OtpDialog
        open={open}
        handleClose={() => setOpen(false)}
        phone={phone}
        new2024BatchMembers={new2024BatchMembers}
        pin={pin}
        onVerify={handleOnVerifyOtp}
      />
      <TextField
        sx={{ mb: 2 }}
        required
        id='outlined-required'
        label='PIN'
        placeholder='Enter your PIN'
        fullWidth
        disabled={new2024BatchMembers}
        autoFocus
        length={6}
        value={pin}
        inputProps={{
          inputMode: 'numeric',
          maxLength: 6
        }}
        onChange={handlePinChange}
      />
      {/* <FormControlLabel
        sx={{
          mb: 3,
          '& .MuiFormControlLabel-label': {
            fontSize: '12px'
          }
        }}
        control={
          <Checkbox
            checked={new2024BatchMembers} onChange={handleCheckboxChange} color='primary'
          />
        }
        label={'I don\'t have a PIN (2024 batch members)'}
      /> */}

      {name &&
        <Box
          display='flex'
          alignItems='center'
          justifyContent='center'
          sx={{
            p: 2,
            border: '1px solid',
            borderRadius: '4px',
            borderColor: 'secondary.main',
            backgroundColor: 'secondary.light',
            mb: 5
          }}
        >
          <Typography
            variant='semi_bold_14_600'
            color='primary'
          >
            👋 Hello, {name}
          </Typography>
        </Box>}

      <TextField
        sx={{ mb: 2, mt: 2 }}
        required
        id='outlined-required'
        label='Mobile number'
        placeholder='Enter your mobile number'
        fullWidth
        length={10}
        value={phone}
        type='tel'
        inputProps={{
          inputMode: 'numeric',
          pattern: '[0-9]*',
          maxLength: 10
        }}
        onChange={(e) => { /^[0-9]*$/.test(e.target.value) && setPhone(e.target.value) }}
        InputProps={{
          startAdornment: <InputAdornment position='start'>+91</InputAdornment>
        }}
      />

      <Grid
        container
              // spacing={2}
        direction='row'
        alignItems='center'
        justifyContent='space-between' sx={{ my: 1 }}
      >
        <Typography sx={{ fontSize: '12px' }} />
        <Grid sx={{ display: 'flex', alignItems: 'center', m: 2 }} container>
          <Typography
            sx={{ fontSize: '14px', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => {
              const phone = '919900556970'
              const message = encodeURIComponent('Hi Chethan 👋, I need some help in applying for a post in cec-selection website.')
              window.open(`https://wa.me/${phone}?text=${message}`, '_blank')
            }}
          >Facing issues while applying? Contact us!
          </Typography>
          <WhatsAppIcon sx={{ width: 20, cursor: 'pointer', color: 'green', ml: 0.5 }} />
        </Grid>
        <Grid item size={{ xs: 12, sm: 1.06, md: 2 }}>
          <Button
            fullWidth
            sx={{ textTransform: 'none' }}
            variant='contained'
            onClick={handleOtpRequest}
            disabled={isDisabled}
          >
            Send OTP
          </Button>
        </Grid>
      </Grid>

    </Container>
  )
}

export default StepOne
